<script setup>
import SectionTitle from '@weathernews/btos-vuecomponent/with-onebox-common-elements/src/components/SectionTitle.vue'

const route = useRoute()
const props = defineProps({
  title: {
    type: String,
    required: true
  },
  lat: {
    type: Number,
    required: true
  },
  lon: {
    type: Number,
    required: true
  }
})
const { data: aroundLivecamList } = await useFetch('/api/livecam/aroundcam', { query: { lat: props.lat, lon: props.lon } })

const { data: results } = await useAsyncData(
  `aroundLivecamList:${route.params.id}`,
  async () => {
    const data = await Promise.all(
      aroundLivecamList.value.map((item) => {
        return $fetch(`/api/livecam/thumbnaildata?id=${item.id}`)
      })
    )
    const sortData = data.filter((result) => result !== undefined)
    return sortData
  }
)
</script>

<template>
  <section class="livecamRowList">
    <SectionTitle
      :title="`${title}周辺のライブカメラ`"
    />
    <ul class="content">
      <li
        v-for="content in results"
        :key="content.text"
      >
        <LivecamBlock
          :text="content.text"
          :link="content.link"
          :date="content.latest"
          :img="content.image"
        />
      </li>
    </ul>
  </section>
</template>

<style scoped>
.livecamRowList {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 10px;
  .content {
    display: flex;
    gap: 6px;
    overflow-x: scroll;
    &::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }
    &::-webkit-scrollbar-track {
      border-radius: 8px;
      background-color: #fff;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 8px;
      background: #438fec;
    }
    li {
      width: calc((100% - 12px) / 3);
      min-width: 153px;
    }
  }
}
</style>
